import { render, staticRenderFns } from "./TodoListView.vue?vue&type=template&id=13a0a90e"
import script from "./TodoListView.vue?vue&type=script&lang=js"
export * from "./TodoListView.vue?vue&type=script&lang=js"
import style0 from "./TodoListView.vue?vue&type=style&index=0&id=13a0a90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports